<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter">
<div class="image">
<p class="noindent1"><img alt="" src="images/image-8.jpg"/></p>
</div>
<p class="hang">Hail, hail, hail.</p>
<p class="hang">May happiness come.</p>
<p class="hang">May meat come,</p>
<p class="hang">May corn come,</p>
<p class="hang">Just as the farmers work,</p>
<p class="hang">And look forward to the reaping.</p>
<p class="hang">So may we sit again as we are sitting now.</p>
<p class="noindent1">PRAYER OF THE GA, GHANA</p>
<div class="image">
<p class="center"><img alt="" src="images/image-9.jpg"/></p>
</div>
<p class="pagebreak"></p>
<p class="noindent"><a id="page10"></a>Think, and thank God.</p>
<p class="noindent1">PROVERB</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Father, we thank Thee for this food,</p>
<p class="hang">For health and strength and all things good.</p>
<p class="hang">May others all these blessings share,</p>
<p class="hang">And hearts be grateful everywhere.</p>
<p class="noindent1">TRADITIONAL AMERICAN BLESSING,<br/>CIRCA 1800s</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page11"></a><img alt="" src="images/image-11.jpg"/></p>
</div>
<p class="noindent">For each new morning with its light,<br/>For rest and shelter of the night,<br/>For health and food,<br/>For love and friends,<br/>For everything Thy goodness sends.</p>
<p class="noindent1">RALPH WALDO EMERSON (1803-1882),<br/>AMERICAN ESSAYIST</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-12.jpg"/></p>
</div>
<p class="noindent">Without Thy sunshine and Thy rain;<br/>We would not have the golden grain;<br/>Without Thy love we’d not be fed;<br/>We thank Thee for our daily bread.</p>
<p class="noindent1">ANONYMOUS</p>
<p class="pagebreak"></p>
<p class="white2"> </p>
<p class="noindent"><a id="page13"></a>Great God accept our gratitude,<br/>For the great gifts on us bestowed—<br/>For raiment, shelter, and for food.<br/>Great God, our gratitude we bring,<br/>Accept our humble offering,<br/>For all the gifts on us bestowed,<br/>Thy name be evermore adored.</p>
<p class="noindent1">JOSEPHINE DELPHINE HENDERSON HEARD (1861-1921), AFRICAN-AMERICAN POET,</p>
<p class="noindent1"><i>DOXOLOGY</i></p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-14.jpg"/></p>
</div>
<p class="hang"><a id="page15"></a>Though our mouths were full of song as the sea,</p>
<p class="hang">And our tongues of exultation as the multitude of its waves,</p>
<p class="hang">And our lips of praise as the wide-extended firmament;</p>
<p class="hang">Though our eyes shone with light like the sun and the moon,</p>
<p class="hang">And our hands were spread forth like the eagles of heaven,</p>
<p class="hang">And our feet were swift as hinds, we should still be unable</p>
<p class="hang">To thank thee and bless Thy name.</p>
<p class="hang">O Lord our God and God of our fathers, for one thousandth</p>
<p class="hang">or one ten-thousandth of the bounties which Thou has bestowed</p>
<p class="hang">Upon our fathers and upon us.</p>
<p class="noindent1">THE HEBREW PRAYER BOOK</p>
<p class="pagebreak"></p>
<p class="noindent"><a id="page16"></a>Blessed are we who can laugh at ourselves,<br/>For we shall never cease to be amused.</p>
<p class="noindent1">ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Now this day,</p>
<p class="hang">My sun father,</p>
<p class="hang">Now that you have come out standing to</p>
<p class="hang">your sacred place,</p>
<p class="hang">That from which we draw the water of life,</p>
<p class="hang">Prayer meal,</p>
<p class="hang">Here I give to you.</p>
<p class="hang">Your long life,</p>
<p class="hang">Your old age,</p>
<p class="hang">Your waters,</p>
<p class="hang">Your seeds,</p>
<p class="hang">Your riches,</p>
<p class="hang">Your power,</p>
<p class="hang">Your strong spirit,</p>
<p class="hang">All these to me may you grant.</p>
<p class="noindent1">ZUÑI PRAYER</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page17"></a><img alt="" src="images/image-17.jpg"/></p>
</div>
<p class="hang">This ritual is One.</p>
<p class="hang">The food is One.</p>
<p class="hang">We who offer the food are One.</p>
<p class="hang">The fire of hunger is also One.</p>
<p class="hang">All action is One.</p>
<p class="hang">We who understand this are One.</p>
<p class="noindent1">HINDU BLESSING</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-18.jpg"/></p>
</div>
<p class="hang"><a id="page19"></a>Been out on the range,</p>
<p class="hang">All dusty and tired.</p>
<p class="hang">Been ridin’ and ropin’ all day,</p>
<p class="hang">Around the chuck wagon.</p>
<p class="hang">We bow down our heads,</p>
<p class="hang">And sing out the cowboys’ grace.</p>
<p class="hang">Allelujah, Amen, Amen.</p>
<p class="hang">Allelujah, Amen, Amen.</p>
<p class="noindent1">A COWBOY GRACE</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page20"></a>Make a joyful noise unto the Lord, all the lands!</p>
<p class="hang">Serve the Lord with gladness!</p>
<p class="hang">Come into His presence with singing!</p>
<p class="hang">Know that the Lord is God!</p>
<p class="hang">It is He that made us, and we are His;</p>
<p class="hang">We are His people, and the sheep of His pasture.</p>
<p class="hang">Enter His gates with thanksgiving,</p>
<p class="hang">And His courts with praise!</p>
<p class="hang">Give thanks to Him, bless His name!</p>
<p class="hang">For the Lord is good;</p>
<p class="hang">His steadfast love endures forever,</p>
<p class="hang">And His faithfulness to all generations.</p>
<p class="noindent1">PSALM 100</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page21"></a><img alt="" src="images/image-21.jpg"/></p>
</div>
<p class="hang">Soup and fish explain half the emotions in life.</p>
<p class="noindent1">SYDNEY SMITH (1771-1845),<br/>ENGLISH CLERGYMAN AT<br/>ST. PAUL’S CATHEDRAL, LONDON</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Praise to God who giveth meat,</p>
<p class="hang">Convenient unto all who eat.</p>
<p class="hang">Praise for tea and buttered toast,</p>
<p class="hang">Father, Son, and Holy Ghost.</p>
<p class="noindent1">SCOTTISH GRACE</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page22"></a><img alt="" src="images/image-22.jpg"/></p>
</div>
<p class="hang">May the abundance of this table</p>
<p class="hang">Never fail and never be less,</p>
<p class="hang">Thanks to the blessings of God,</p>
<p class="hang">Who has satisfied our needs.</p>
<p class="hang">To Him be the glory forever.</p>
<p class="hang">Amen.</p>
<p class="noindent1">ARMENIAN GRACE, LEBANON</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page23"></a>Oh Lord, now bless and bind us.</p>
<p class="hang">And put old Satan ‘hind us.</p>
<p class="hang">Oh let your spirit mind us.</p>
<p class="hang">Don’t let none hungry find us.</p>
<p class="noindent1"><i>BLESSING WITH COMPANY PRESENT</i>,<br/>AFRICAN-AMERICAN FOLK RHYME,<br/>18TH CENTURY</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Turkey boiled is turkey spoiled;</p>
<p class="hang">And turkey roast is turkey lost.</p>
<p class="hang">But for turkey braised,</p>
<p class="hang">The Lord be praised.</p>
<p class="noindent1">ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-23.jpg"/></p>
</div>
<p class="pagebreak"></p>
<p class="hang"><a id="page24"></a>A table is not blessed if it has fed no scholars.</p>
<p class="noindent1">YIDDISH PROVERB</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">For these and all Thy blessings so kindly bestowed upon us, our most sincere thanks, dear Ahura Mazda.</p>
<p class="noindent1">ZOROASTER, LATE 7TH TO <br/>EARLY 6TH CENTURY, <span class="small">B.C.</span>,<br/><i>GRACE AT MEAL TIMES</i></p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Lord Jesus, be our guest;</p>
<p class="hang">Our morning joy, our evening rest.</p>
<p class="hang">And with our daily bread, and part,</p>
<p class="hang">Bring peace and joy to every heart.</p>
<p class="hang">Amen.</p>
<p class="noindent1">TRADITIONAL AMERICAN GRACE</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page25"></a>Time is</p>
<p class="hang">Too slow for those who wait,</p>
<p class="hang">Too swift for those who fear,</p>
<p class="hang">Too long for those who grieve,</p>
<p class="hang">Too short for those who rejoice.</p>
<p class="hang">But for those who love,</p>
<p class="hang">Time is eternity.</p>
<p class="hang">Hours fly, flowers die,</p>
<p class="hang">New days, new ways pass by,</p>
<p class="hang">Love stays.</p>
<p class="noindent1">HENRY VAN DYKE (1852-1933),<br/>AMERICAN CLERGYMAN AND WRITER<br/>
  (found on a sundial at the University of Virginia)</p>
<div class="image">
<p class="center"><img alt="" src="images/image-25.jpg"/></p>
</div>
<p class="pagebreak"></p>
<p class="hang"><a id="page26"></a>O you who believe!</p>
<p class="hang">Eat of the good things that we have provided for you, and be grateful to Allah.</p>
<p class="hang">It is He you worship.</p>
<p class="noindent1">ISLAMIC PRAYER</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-27.jpg"/></p>
</div>
<p class="hang"><a id="page28"></a>God has two dwellings:</p>
<p class="hang">One in heaven, and the other in a meek and thankful heart.</p>
<p class="noindent1">IZAAK WALTON (1593-1683),<br/>ENGLISH BIOGRAPHER AND AUTHOR</p>
<div class="image">
<p class="center"><img alt="" src="images/image-28.jpg"/></p>
</div>
<p class="pagebreak"></p>
<p class="hang"><a id="page29"></a>Lord, bless this food</p>
<p class="hang">  Before we eat.</p>
<p class="hang">Bless Thou the bread,</p>
<p class="hang">And bless the meat.</p>
<p class="hang">Amen.</p>
<p class="noindent1">ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">For peaceful homes, and healthful days,</p>
<p class="hang">For all the blessings Earth displays,</p>
<p class="hang">We owe Thee thankfulness and praise,</p>
<p class="hang">Giver of all!</p>
<p class="noindent1">CHRISTOPHER WADSWORTH (1807-1885),<br/>ANGLICAN BISHOP</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page-30"></a><img alt="" src="images/image-30.jpg"/></p>
</div>
<p class="hang"><a id="page31"></a>All my soul is in delight,</p>
<p class="hang">When Mommy fixes kraut just right.</p>
<p class="noindent1">FROM AN EARLY PENNSYLVANIA DUTCH SONG</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page32"></a>They that have no other meat,</p>
<p class="hang">Bread and butter are glad to eat.</p>
<p class="noindent1">JOHN RAY (1627-1705),<br/>
  ENGLISH NATURALIST AND COLLECTOR OF PROVERBS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-32.jpg"/></p>
</div>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page33"></a><img alt="" src="images/image-33.jpg"/></p>
</div>
<p class="hang">O Lord, bless the waters of the river.</p>
<p class="hang">Gladden the face of the earth.</p>
<p class="hang">May her furrows be watered, her fruits multiply;</p>
<p class="hang">Prepare it for seed and harvest.</p>
<p class="noindent1">EGYPTIAN PRAYER FOR THE RISING OF THE NILE</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-34.jpg"/></p>
</div>
<p class="hang"><a id="page35"></a>Heaven,</p>
<p class="hang">Please make the rain fall,</p>
<p class="hang">So I have water to drink;</p>
<p class="hang">So I may plow my rice field;</p>
<p class="hang">So I may have my bowl of rice;</p>
<p class="hang">And my fish in great slices.</p>
<p class="noindent1">VIETNAMESE FARMERS’ PRAYER</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page36"></a>Anticipate the good so that you may enjoy it.</p>
<p class="noindent1">ETHIOPIAN PROVERB</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">How beautiful and perfect are the animals!</p>
<p class="hang">How perfect the Earth, and the minutest thing on it!</p>
<p class="hang">What is called good is perfect, and what is called bad is just as perfect;</p>
<p class="hang">The vegetables and minerals are all perfect, and the imponderable fluids perfect.</p>
<p class="hang">Slowly and surely they have pass’d on to this, and slowly and surely they yet pass on.</p>
<p class="hang">I swear I think there is nothing but immortality.</p>
<p class="noindent1">WALT WHITMAN (1819-1892),<br/>AMERICAN WRITER, <i>LEAVES OF GRASS</i></p>
<p class="pagebreak"></p>
<p class="hang"><a id="page37"></a>God is great!</p>
<p class="hang">God is good!</p>
<p class="hang">Let us thank Him</p>
<p class="hang">For our food.</p>
<p class="hang">Amen.</p>
<p class="noindent1">TRADITIONAL AMERICAN GRACE</p>
<div class="image">
<p class="center"><img alt="" src="images/image-37.jpg"/></p>
</div>
<p class="pagebreak"></p>
<p class="hang"><a id="page38"></a>Olodumare, oh Divine One!</p>
<p class="hang">I give thanks to You,</p>
<p class="hang">The one who is as near as my heartbeat,</p>
<p class="hang">And more anticipated than my next breath.</p>
<p class="hang">Let Your wisdom become one with this vessel,</p>
<p class="hang">As I lift my voice in thanks for Your love.</p>
<p class="noindent1">YORUBAN BLESSING</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">There is enough in the world for everyone to have plenty to live on happily and to be at peace with his neighbors.</p>
<p class="noindent1">HARRY S. TRUMAN (1884-1972),<br/>33RD U.S. PRESIDENT</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page39"></a>Grub first, then ethics.</p>
<p class="noindent1">BERTOLT BRECHT (1898-1956),<br/>GERMAN WRITER</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">This night I hold an old accustom’d feast,</p>
<p class="hang">Whereto I have invited many a guest,</p>
<p class="hang">Such as I love; and you among them the store,</p>
<p class="hang">One more, most welcome, makes my numbers more.</p>
<p class="noindent1">WILLIAM SHAKESPEARE (1564-1616), <i>ROMEO AND JULIET</i>, ACT 1, SC. 2, LINE 20</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page40"></a><img alt="" src="images/image-40.jpg"/></p>
</div>
<p class="hang">Lord most giving and resourceful, I implore you;</p>
<p class="hang">Make it your will that this people enjoy</p>
<p class="hang">The goods and riches you naturally give,</p>
<p class="hang">That naturally issue from you,</p>
<p class="hang">That are pleasing and savory,</p>
<p class="hang">That delight and comfort,</p>
<p class="hang">Though lasting but briefly,</p>
<p class="hang">Passing away as if in a dream.</p>
<p class="noindent1">AZTEC PRAYER, CIRCA 1500s</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page41"></a>Eat your bread with joy;</p>
<p class="hang">Drink your wine with a merry heart.</p>
<p class="noindent1">ECCLESIASTES 9:7</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Prevail on each god to give us his bounty!</p>
<p class="hang">Now at your appealing import to us the charm</p>
<p class="hang">Of pleasant voices and for our own uplift.</p>
<p class="hang">Preserve us evermore, O gods, with your blessing!</p>
<p class="noindent1"><i>BHAGAVAD GITA</i>, HINDU BLESSING</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page42"></a><i>To be said while holding hands:</i></p>
<p class="hang">May the love that is in my heart pass from my hand to yours.</p>
<p class="noindent1">TRADITIONAL AMERICAN GRACE</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-43.jpg"/></p>
</div>
<div class="image">
<p class="center"><a id="page44"></a><img alt="" src="images/image-44.jpg"/></p>
</div>
<p class="hang">Before me, may it be delightful.</p>
<p class="hang">Behind me, may it be delightful.</p>
<p class="hang">Around me, may it be delightful.</p>
<p class="hang">Below me, may it be delightful.</p>
<p class="hang">Above me, may it be delightful.</p>
<p class="hang">All, may it be delightful.</p>
<p class="noindent1">NAVAJO PRAYER</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page45"></a>Praised are You, Adonai our God, Guide of the Universe,</p>
<p class="hang">Who creates innumerable living beings and their needs, for all the things</p>
<p class="hang">You have created to sustain every living being.</p>
<p class="hang">Praised are You, the life of the Universe.</p>
<p class="noindent1">JEWISH BLESSING</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">May the longtime sun shine</p>
<p class="hang">Upon you, all love surround you,</p>
<p class="hang">And the sweet light within you</p>
<p class="hang">Guide you on your way.</p>
<p class="noindent1">TRADITIONAL IRISH BLESSING</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page46"></a>Do good and don’t look back.</p>
<p class="noindent1">DUTCH PROVERB</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">May the blessing of God rest upon you,</p>
<p class="hang">May his peace abide within you,</p>
<p class="hang">May his presence illuminate your heart,</p>
<p class="hang">Now and forevermore.</p>
<p class="noindent1">SUFI BLESSING</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page47"></a>May there always be work for your hands to do;</p>
<p class="hang">May your purse always hold a coin or two;</p>
<p class="hang">May the sun always shine upon your windowpane;</p>
<p class="hang">May a rainbow be certain to follow each rain;</p>
<p class="hang">May the hand of a friend always be near to you, and</p>
<p class="hang">May God fill your heart with gladness to cheer you.</p>
<p class="noindent1">IRISH BLESSING</p>
<div class="image">
<p class="center"><img alt="" src="images/image-47.jpg"/></p>
</div>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page48"></a><img alt="" src="images/image-48.jpg"/></p>
</div>
<p class="hang">When eating bamboo shoots,</p>
<p class="hang">remember the man who planted them.</p>
<p class="noindent1">CHINESE PROVERB</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page49"></a>Now that I am about to eat, O Great Spirit, </p>
<p class="hang">Give my thanks to the beasts and birds</p>
<p class="hang"> Whom you have provided for my hunger; </p>
<p class="hang">And pray deliver my sorrow</p>
<p class="hang">That living things must make a sacrifice for my comfort and well-being.</p>
<p class="hang">Let the feather of corn spring up in its time</p>
<p class="hang">And let it not wither but make full grains</p>
<p class="hang">For the fires of our cooking pots,</p>
<p class="hang">Now that I am about to eat.</p>
<p class="noindent1">NATIVE AMERICAN GRACE</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page50"></a>Bless this food we are about to receive.</p>
<p class="hang">Give bread to those who hunger,</p>
<p class="hang">And hunger for justice to us who have bread.</p>
<p class="hang">Amen.</p>
<p class="noindent1">TRADITIONAL AMERICAN GRACE</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Be present at our table, Lord;</p>
<p class="hang">Be here, and everywhere adored;</p>
<p class="hang">Thy mercies bless and grant that we</p>
<p class="hang">May feast in fellowship with Thee.</p>
<p class="hang">Amen.</p>
<p class="noindent1">ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Round the table;</p>
<p class="hang">Peace and joy prevail.</p>
<p class="hang">May all who share</p>
<p class="hang">This season’s delight</p>
<p class="hang">Enjoy countless more.</p>
<p class="noindent1">CHINESE BLESSING</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page51"></a>Bless us, O Lord, and these Thy gifts which we are about to receive</p>
<p class="hang">From Thy bounty, through Christ our Lord.</p>
<p class="hang">Amen.</p>
<p class="hang"><i>(same quote in Latin)</i></p>
<p class="hang">Benedic, Domine, nos et haec tua dona quae de tua largitate sumus sumpturi. Per Christum Dominum nostrum.</p>
<p class="hang">Amen.</p>
<p class="noindent1">TRADITIONAL CATHOLIC PRAYER BEFORE MEALS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-37.jpg"/></p>
</div>
<p class="pagebreak"></p>
<p class="hang"><a id="page52"></a>Hold on to what is good even if it is a handful of earth.</p>
<p class="hang">Hold on to what you believe even if it is a tree that stands by itself.</p>
<p class="hang">Hold on to what you must do even if it is a long way from here.</p>
<p class="hang">Hold on to life even when it is easier letting go.</p>
<p class="hang">Hold on to my hand even when I have gone away from you.</p>
<p class="noindent1">PUEBLO VERSE</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page53"></a><img alt="" src="images/image-53.jpg"/></p>
</div>
<p class="hang">Rub-a-dub-dub,</p>
<p class="hang">Thanks for the grub.</p>
<p class="hang">Yea, God!</p>
<p class="noindent1">ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Bless us O Lord, for these gifts</p>
<p class="hang">we are about to receive from your bounty.</p>
<p class="noindent1">TRADITIONAL CHRISTIAN GRACE, CIRCA 1800s</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page54"></a>Everyone at the table join hands for a silent moment.</p>
<p class="noindent1">QUAKER GRACE</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">In plenty think of want; in want, do not presume on plenty.</p>
<p class="noindent1">CHINESE PROVERB</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page55"></a>That is perfect. This is perfect.</p>
<p class="hang">Perfect comes from perfect.</p>
<p class="hang">Take perfect from perfect,</p>
<p class="hang">The remainder is perfect.</p>
<p class="hang">May peace and peace and</p>
<p class="hang">Peace be everywhere.</p>
<p class="noindent1"><i>THE UPANISHADS</i>, SACRED HINDU TEXT, CIRCA 2500 <span class="small">B.C.</span></p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Bless these Thy gifts, most gracious God,</p>
<p class="hang">From whom all goodness springs;</p>
<p class="hang">Make clean our hearts and feed our souls,</p>
<p class="hang">With good and joyful things.</p>
<p class="noindent1">TRADITIONAL CHRISTIAN GRACE</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page56"></a>The custom of saying grace at meals had,</p>
<p class="hang">probably, its origin in the early times of</p>
<p class="hang">the world, and the hunter-state of man,</p>
<p class="hang">when dinners were precarious things, and</p>
<p class="hang">a full meal was something more than a</p>
<p class="hang">common blessing; when a bellyful was a</p>
<p class="hang">windfall, and looked like a special providence.</p>
<p class="noindent1">CHARLES LAMB (1775-1834),<br/>ENGLISH ESSAYIST, <i>GRACE BEFORE MEAT</i></p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page57"></a><img alt="" src="images/image-57.jpg"/></p>
</div>
<p class="hang">Gracias, arigato, merci beaucoup.<br/><i>(clap clap)</i></p>
<p class="hang">Gracias, arigato, merci beaucoup.<br/><i>(clap clap)</i></p>
<p class="hang">I can say thank you to God<br/><i>(clap clap)</i></p>
<p class="hang">in Spanish, Japanese, French words, too.<br/><i>(clap clap)</i></p>
<p class="noindent1">CHILDREN’S RHYME</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-58.jpg"/></p>
</div>
<p class="hang"><a id="page59"></a>Aloha to God above.</p>
<p class="hang">Aloha, a word that means</p>
<p class="hang">I love you.</p>
<p class="hang">Mahalo, too, means</p>
<p class="hang">I thank you.</p>
<p class="hang">Mahalo, aloha to God.</p>
<p class="hang">(Ma/ha/low)</p>
<p class="noindent1">HAWAIIAN GRACE</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page60"></a>So I may raise corn,</p>
<p class="hang">So I may raise beans,</p>
<p class="hang">So I may raise wheat,</p>
<p class="hang">So I may raise squash,</p>
<p class="hang">So that with all good fortune I may be blessed.</p>
<p class="noindent1">PUEBLO BLESSING</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-61.jpg"/></p>
</div>
<p class="hang"><a id="page62"></a>Give me a good digestion, Lord,</p>
<p class="hang">And also something to digest.</p>
<p class="hang">Give me a healthy body, Lord,</p>
<p class="hang">With sense to keep it at its best.</p>
<p class="hang">Give me a healthy mind, Lord,</p>
<p class="hang">To keep the good and pure in sight;</p>
<p class="hang">Which, seeing sin, is not appalled,</p>
<p class="hang">But finds a way to set it right.</p>
<p class="hang">Give me a mind that is not bored,</p>
<p class="hang">That does not whimper, whine, or sigh.</p>
<p class="hang">Don’t let me worry overmuch</p>
<p class="hang">About the fussy thing called “I.”</p>
<p class="hang">Give me a sense of humor, Lord;</p>
<p class="hang">Give me the grace to see a joke;</p>
<p class="hang">To get some happiness from life,</p>
<p class="hang">And pass it on to other folk.</p>
<p class="noindent1">A PRAYER FOUND IN CHESTER CATHEDRAL, CIRCA 1850</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page63"></a>Heavenly Father, bless us</p>
<p class="hang">And keep us all alive,</p>
<p class="hang">There’s ten of us to dinner</p>
<p class="hang">And not enough for five.</p>
<p class="noindent1">ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Thou hast given so much to me…</p>
<p class="hang">Give me one thing more—</p>
<p class="hang">A grateful heart.</p>
<p class="noindent1">GEORGE HERBERT (1593-1633),<br/>ENGLISH POET AND PASTOR</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-64.jpg"/></p>
</div>
<p class="hang"><a id="page65"></a>A haze on the far horizon,</p>
<p class="hang">The infinite, tender sky,</p>
<p class="hang">The ripe, rich tint of the cornfields,</p>
<p class="hang">And then wild geese sailing high—</p>
<p class="hang">All over upland and lowland</p>
<p class="hang">The charms of all the goldenrod—</p>
<p class="hang">Some of us call it autumn,</p>
<p class="hang">And others call it God.</p>
<p class="noindent1">WILLIAM HERBERT CARRUTH (1859-1924), AMERICAN EDUCATOR</p>
<p class="pagebreak"></p>
<div class="floatleft">
<p class="center"><a id="page66"></a><img alt="" src="images/image-66.jpg"/></p>
</div>
<p class="noindent">There’s no joy in anything unless we share it.</p>
<p class="noindent1">AMERICAN PROVERB</p>
<div class="clear"></div>
<p class="pagebreak"></p>
<p class="hang"><a id="page67"></a>For all that God in mercy sends,</p>
<p class="hang">For health and children, home and friends,</p>
<p class="hang">For comfort in the time of need,</p>
<p class="hang">For every kindly word and deed,</p>
<p class="hang">For happy thoughts and holy talk,</p>
<p class="hang">For guidance in our daily walk,</p>
<p class="hang">For everything give thanks!</p>
<p class="hang">For beauty in this world of ours,</p>
<p class="hang">For verdant grass and lovely flowers,</p>
<p class="hang">For song of birds, for hum of bees,</p>
<p class="hang">For refreshing summer breeze,</p>
<p class="hang">For hill and plain, for streams and wood,</p>
<p class="hang">For the great ocean’s mighty flood.</p>
<p class="hang">For everything give thanks!</p>
<p class="hang">For sweet sleep which comes with night.</p>
<p class="hang">For the returning morning light,</p>
<p class="hang">For the bright sun that shines on high,</p>
<p class="hang">For the stars glittering in the sky,</p>
<p class="hang">For these and everything we see,</p>
<p class="hang">O Lord, our hearts we lift to Thee</p>
<p class="hang">For everything give thanks!</p>
<p class="noindent1">HELENA ISABELLA TUPPER (date unknown),<br/><i>FOR EVERYTHING GIVE THANKS</i></p>
<p class="pagebreak"></p>
<p class="hang"><a id="page68"></a>Give strength, give thought, give deeds, give wealth;</p>
<p class="hang">Give love, give tears, and give thyself.</p>
<p class="hang">Give, give, be always giving;</p>
<p class="hang">Who gives not is not living.</p>
<p class="hang">The more you give, the more you live.</p>
<p class="noindent1">ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">The worship most acceptable to God</p>
<p class="hang">comes from a thankful and cheerful heart.</p>
<p class="noindent1">PLUTARCH (CIRCA <span class="small">A.D.</span> 46-120),<br/>GREEK BIOGRAPHER AND ESSAYIST</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page69"></a>The Holy Supper is kept, indeed,</p>
<p class="hang">In what so we share with another’s need;</p>
<p class="hang">Not what we give, but what we share,</p>
<p class="hang">For the gifts without the giver is bare;</p>
<p class="hang">Who gives himself with his alms feeds three:</p>
<p class="hang">Himself, his neighbor, and me.</p>
<p class="noindent1">JAMES RUSSELL LOWELL (1819-1891),<br/><i>THE VISION OF SIR LAUNFOL</i></p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page70"></a><img alt="" src="images/image-70.jpg"/></p>
</div>
<p class="hang">Praised be my Lord for our</p>
<p class="hang">Mother the Earth, which</p>
<p class="hang">Sustains us and keeps us and</p>
<p class="hang">Brings forth diverse fruits,</p>
<p class="hang">And flowers of many colors—</p>
<p class="hang">And grass.</p>
<p class="noindent1">ST. FRANCIS OF ASSISI (1181-1226),<br/><i>THE CANTICLE OF THE CREATURES</i></p>
<p class="pagebreak"></p>
<p class="hang"><a id="page71"></a>Good bread,</p>
<p class="hang">Good meat;</p>
<p class="hang">Good God</p>
<p class="hang">Let’s eat.</p>
<p class="noindent1">ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">May we be a channel of blessings,</p>
<p class="hang">For all that we meet.</p>
<p class="noindent1">EDGAR CAYCE (1877-1945),<br/>AMERICAN PSYCHIC</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page72"></a>Gratitude is the heart’s memory.</p>
<p class="noindent1">ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Some hae meat, and canna eat,</p>
<p class="hang">And some wad eat that want it,</p>
<p class="hang">But we hae meat and we can eat,</p>
<p class="hang">And sae the Lord be thank it.</p>
<p class="noindent1">ROBERT BURNS (1759-1796), SCOTLAND’S NATIONAL POET, <i>THE SELKIRK GRACE</i></p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Gratitude is from the same root<br/>word as “grace,” which signifies<br/>the free boundless mercy of God.</p>
<p class="hang">Thanksgiving is from the same root<br/>word as “think,” so that to think<br/>is to thank.</p>
<p class="noindent1">WILLIS P. KING, <i>PULPIT PREACHING</i> (date unknown)</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page73"></a><img alt="" src="images/image-73.jpg"/></p>
</div>
<p class="hang">As Thou has set the moon in the sky to be the poor man’s lantern,</p>
<p class="hang">So let Thy light shine in my dark life and lighten my path;</p>
<p class="hang">As the rice is sown in the water,</p>
<p class="hang">And brings forth grain in great abundance, so let Thy word be sown in our</p>
<p class="hang">Midst that the harvest may be great; and as the banyan sends forth its</p>
<p class="hang">Branches to take root in our lives.</p>
<p class="noindent1">SOUTHERN INDIAN PRAYER, SOURCE UNKNOWN</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page74"></a><img alt="" src="images/image-74.jpg"/></p>
</div>
<p class="hang">We cannot love God unless we love each other,</p>
<p class="hang">And to love each other we must know each other</p>
<p class="hang">In the breaking of bread and we are not alone anymore.</p>
<p class="hang">Heaven is a banquet and Life is a banquet, too,</p>
<p class="hang">Even with a crust, where there is companionship,</p>
<p class="hang">Love comes with community.</p>
<p class="noindent1">DOROTHY DAY (1897-1980),<br/>
  COFOUNDER OF U.S. CATHOLIC WORKER MOVEMENT</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page75"></a>Lord behold our family here assembled.</p>
<p class="hang">We thank Thee for this place in which</p>
<p class="hang">We dwell, for the love that unites us, for</p>
<p class="hang">The peace accorded us this day, for the</p>
<p class="hang">Health, the work, the food, and the bright</p>
<p class="hang">Skies that make our lives delightful, for</p>
<p class="hang">Our friends in all parts of the earth.</p>
<p class="hang">Give us courage, gaiety, and the quiet mind.</p>
<p class="hang">Spare to us our friends, soften to us our enemies.</p>
<p class="hang">Bless us, if it may be, in all our innocent endeavors.</p>
<p class="hang">If it may not, give us the strength to encounter that which is to come.</p>
<p class="hang">May we be brave in peril, constant in tribulation, temperate in wrath,</p>
<p class="hang">And in all changes of fortune loyal and loving to one another.</p>
<p class="noindent1">ROBERT LOUIS STEVENSON (1850-1894), SCOTTISH NOVELIST AND POET</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page76"></a>Here’s to those who love us,</p>
<p class="hang">And here’s to those who don’t.</p>
<p class="hang">A smile for those who are willing to,</p>
<p class="hang">And a tear for those who won’t.</p>
<p class="noindent1">ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">From too much love of living,</p>
<p class="hang">From hope and fear set free,</p>
<p class="hang">We thank with brief Thanksgiving</p>
<p class="hang">Whatever gods may be.</p>
<p class="noindent1">ALGERNON CHARLES SWINBURNE (1837-1909),</p>
<p class="noindent1"> <i>THE GARDEN OF PROSERPINE</i></p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page77"></a><img alt="" src="images/image-77.jpg"/></p>
</div>
<p class="hang">For flowers so beautiful and sweet,</p>
<p class="hang">For friends and clothes and food to eat,</p>
<p class="hang">For gracious hours, for work and play,</p>
<p class="hang">We thank Thee this Thanksgiving Day.</p>
<p class="hang">For father’s care and mother’s love,</p>
<p class="hang">For blue sky and clouds above.</p>
<p class="hang">For springtime and for autumn gay.</p>
<p class="hang">We thank Thee this Thanksgiving Day.</p>
<p class="hang">For all Thy gifts so good and fair,</p>
<p class="hang">Bestowed so freely everywhere.</p>
<p class="hang">Give us grateful hearts, we pray,</p>
<p class="hang">To thank Thee this Thanksgiving Day.</p>
<p class="noindent1">MATTIE M. RENWICK (1897-1920),<br/>MICHIGAN POET</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page78"></a>For All Thy Blessings,</p>
<p class="hang">For this new morning and its light,</p>
<p class="hang">The rest and shelter of the night,</p>
<p class="hang">For health and food, love and friends,</p>
<p class="hang">For every gift His goodness sends,</p>
<p class="hang">We thank Thee, gracious Lord.</p>
<p class="hang">Amen.</p>
<p class="noindent1">ANONYMOUS</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page79"></a>The truths of the spirit are proved not by reasoning about them,</p>
<p class="hang">Or finding explanation of them, but only by acting upon them.</p>
<p class="hang">Their life is dependent upon what we do about them.</p>
<p class="hang">Mercy, gentleness, forgiveness, patience;</p>
<p class="hang">If we do not show them, they will cease to be.</p>
<p class="hang">Upon us depends the reality of God here on Earth today.</p>
<p class="noindent1">EDITH HAMILTON (1867-1963),<br/>AMERICAN EDUCATOR AND GREEK SCHOLAR</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page80"></a>Do all the good you can</p>
<p class="hang">By all the means you can,</p>
<p class="hang">In all ways you can,</p>
<p class="hang">In all places you can,</p>
<p class="hang">To all the people you can,</p>
<p class="hang">As long as ever you can.</p>
<p class="noindent1">JOHN WESLEY (1703-1791),<br/>FOUNDER OF THE METHODISTS</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page81"></a><img alt="" src="images/image-81.jpg"/></p>
</div>
<p class="hang">Give us this day our daily bread.</p>
<p class="noindent1">MATTHEW 6:11</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">As the sun illuminates the moon and stars,</p>
<p class="hang">So let us illumine one another.</p>
<p class="noindent1">ANONYMOUS</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page82"></a><img alt="" src="images/image-82.jpg"/></p>
</div>
<p class="hang">A grateful thought toward Heaven<br/>is a complete prayer.</p>
<p class="noindent1">GERMAN PROVERB</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">A crust eaten in peace is better</p>
<p class="hang">than a banquet partaken in anxiety.</p>
<p class="noindent1">AESOP (550 <span class="small">B.C.</span>), <i>THE TOWN MOUSE AND THE COUNTRY MOUSE</i></p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">What hymns are sung, what praises said,</p>
<p class="hang">For home-made miracles of bread.</p>
<p class="noindent1">LOUIS UNTERMEYER (1885-1978),<br/>AMERICAN POET AND ANTHOLOGIST</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page83"></a>For all things, and good, and true;</p>
<p class="hang">For all things that seemed not yet good yet turned to good;</p>
<p class="hang">For all the sweet compulsions of Thy will,</p>
<p class="hang">That chastened, tried, and wrought us to Thy shape;</p>
<p class="hang">For things unnumbered that we take of right,</p>
<p class="hang">And value first when they are withheld;</p>
<p class="hang">For light and air; sweet sense of sound and smell;</p>
<p class="hang">For ears to hear the heavenly harmonies;</p>
<p class="hang">For eyes to see the unseen in the seen;</p>
<p class="hang">For vision of the Wonder in the work;</p>
<p class="hang">For hearts to apprehend Thee everywhere;</p>
<p class="hang">We thank Thee, Lord.</p>
<p class="noindent1">JOHN OXENHAM (1861-1941),<br/>ENGLISH POET, <i>THANKSGIVING</i></p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page84"></a><img alt="" src="images/image-84.jpg"/></p>
</div>
<p class="hang"><i>Tune: “Yankee Doodle”</i></p>
<p class="hang">Thank you Lord for food and drink,</p>
<p class="hang">For warm and sunny weather,</p>
<p class="hang">Thank you Lord for all we have,</p>
<p class="hang">And that we’re all together.</p>
<p class="hang">Thank you Lord for Jesus Christ,</p>
<p class="hang">Thanks for our salvation.</p>
<p class="hang">Thanks for dying on the cross,</p>
<p class="hang">For us and every nation. Amen.</p>
<p class="noindent1">GIRL SCOUT CAMPFIRE GRACE</p>
<p class="pagebreak"></p>
<p class="noindent"><a id="page85"></a><i>Tune (can be done as a round): “Row, Row, Row, Your Boat”</i></p>
<p class="hang">Thank, thank, thank you God.</p>
<p class="hang">Thank you now we pray.</p>
<p class="hang">You have given all we need,</p>
<p class="hang">To live through every day.</p>
<p class="noindent1">GIRL SCOUT CAMPFIRE GRACE</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang"><i>Tune: “Rock Around the Clock”</i></p>
<p class="hang">God is great; God is good.</p>
<p class="hang">Let us thank Him for our food.</p>
<p class="hang">We’re gonna thank the Lord in broad daylight.</p>
<p class="hang">We’re gonna thank Him in the moon at night.</p>
<p class="hang">We’re gonna thank our Lord for He is good!</p>
<p class="hang">Amen.</p>
<p class="noindent1">GIRL SCOUT CAMPFIRE GRACE</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page86"></a><i>Tune: “When Irish Eyes Are Smiling”</i></p>
<p class="hang">May the road rise up to meet you,</p>
<p class="hang">May the wind be at your back,</p>
<p class="hang">May good friends be there to greet you</p>
<p class="hang">And your table never lack.</p>
<p class="hang">May your life be filled with laughter,</p>
<p class="hang">And your heart be filled with song.</p>
<p class="hang"> May God shine His light upon you,</p>
<p class="hang">As you live your whole life long.</p>
<p class="noindent1">TRADITIONAL IRISH BLESSING</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page87"></a><img alt="" src="images/image-87.jpg"/></p>
</div>
<p class="hang">Thank you for the world so sweet,</p>
<p class="hang">Thank you for the food we eat.</p>
<p class="hang">Thank you for the birds that sing,</p>
<p class="hang">Thank you God for everything.</p>
<p class="noindent1">CHILD’S BLESSING</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page88"></a>Father, bless the food we take,</p>
<p class="hang">And bless us all for Jesus’ sake.</p>
<p class="hang">Amen.</p>
<p class="noindent1">ANONYMOUS, <i>A SIMPLE GRACE</i></p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Reflect upon your present blessings,</p>
<p class="hang">Of which every man has plenty;</p>
<p class="hang">Not on your past misfortunes,</p>
<p class="hang">Of which all men have some.</p>
<p class="noindent1">CHARLES DICKENS (1812-1870),<br/>ENGLISH WRITER</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">I ain’t what I wana be.</p>
<p class="hang">I ain’t what I’m gona be.</p>
<p class="hang">But O Lord,</p>
<p class="hang">I ain’t what I used to be.</p>
<p class="noindent1">AUTHOR OF <i>AN UNKNOWN SLAVE</i><br/>(date unknown)</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page89"></a>To live content with small means; to seek elegance rather than luxury;</p>
<p class="hang">And refinement rather than fashion; to be worthy, not respectable;</p>
<p class="hang">And wealthy, not rich; to study hard, think quietly. talk gently,</p>
<p class="hang">Act frankly; to listen to stars and birds, to babes and sages, with open heart;</p>
<p class="hang">To bear all cheerfully, do all bravely, await occasion, hurry never; in a word,</p>
<p class="hang">To let the spiritual, unbidden, and unconscious grow up through the common.</p>
<p class="hang">This is to be my symphony.</p>
<p class="noindent1">WILLIAM ELLERY CHANNING (1780-1842),<br/>
  AMERICAN UNITARIAN MINISTER, <i>MY SYMPHONY</i></p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-90.jpg"/></p>
</div>
<p class="hang">May we walk with grace,</p>
<p class="hang">And may the light of the universe</p>
<p class="hang">Shine upon our path.</p>
<p class="noindent1">ANONYMOUS</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page91"></a>How would it be,</p>
<p class="hang">If just for today,</p>
<p class="hang">We thought less about contests and rivalries,</p>
<p class="hang">Profits and politics,</p>
<p class="hang">Winners and sinners,</p>
<p class="hang">And more about</p>
<p class="hang">Helping and giving,</p>
<p class="hang">Mending and blending,</p>
<p class="hang">Reaching out,</p>
<p class="hang">And pitching in?</p>
<p class="hang">How would it be?</p>
<p class="noindent1">ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Quietly, easily, restfully, patiently,</p>
<p class="hang">serenely, peacefully, joyously, courageously,</p>
<p class="hang">confidently, trustfully</p>
<p class="noindent1">CHARLES R. BROWN (1862-1950),<br/>AMERICAN CLERGYMAN AND EDUCATOR</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page92"></a>To everything there is a season, and a time to every purpose under heaven:</p>
<p class="hang">A time to be born, and a time to die; a time to plant, and a time to pluck up that which is planted;</p>
<p class="hang">A time to kill, and a time to heal; a time to break down, and a time to build up;</p>
<p class="hang">A time to weep, and a time to laugh; a time to mourn, and a time to dance…</p>
<p class="hang">A time to rend, and a time to sew; a time to keep long silence, and a time to speak;</p>
<p class="hang">A time to love, and a time to hate; a time of war, and a time of peace.</p>
<p class="noindent1">ECCLESIASTES 3:1-4, 7-8</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Without Thy sunshine and Thy rain, </p>
<p class="hang">We could not have the golden grain.</p>
<p class="hang">Without Thy love we’d not be fed;</p>
<p class="hang">We thank Thee for our daily bread.</p>
<p class="noindent1">ANONYMOUS</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page93"></a>Consider your table as a table before the Lord: chew well and hurry not.</p>
<p class="noindent1"><i>ZOHAR</i>, THE HEBREW BOOK OF SPLENDOR</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">The wealth of a man is the number</p>
<p class="hang">Of things which he loves and blesses,</p>
<p class="hang">And which he is loved and blessed by.</p>
<p class="noindent1">THOMAS CARLYLE (1795—1881),<br/>ENGLISH WRITER</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">It’s a beautiful world to see,</p>
<p class="hang">Or it’s dismal in every zone.</p>
<p class="hang">The thing it must be in its gloom or its gleam,</p>
<p class="hang">Depends on yourself alone.</p>
<p class="noindent1">ANONYMOUS</p>
<p class="pagebreak"></p>
<p class="noindent"><a id="page94"></a>We ought all to make an effort to act on our first thoughts and let our unspoken gratitude find expression. Then there will be more sunshine in the world, and more power to work for what is good.</p>
<p class="noindent1">ALBERT SCHWEITZER (1875-1965),<br/>
  GERMAN MEDICAL MISSIONARY, <i>MEMORIES OF CHILDHOOD AND YOUTH</i></p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">If there is righteousness in the heart,</p>
<p class="hang">There will be beauty in the character.</p>
<p class="hang">If there is beauty in the character,</p>
<p class="hang">There will be harmony in the home.</p>
<p class="hang">If there is harmony in the home,</p>
<p class="hang">There will be order in the nation.</p>
<p class="hang">When there is order in the nation,</p>
<p class="hang">There will be peace in the world.</p>
<p class="noindent1">CHINESE PROVERB</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page95"></a><img alt="" src="images/image-95.jpg"/></p>
</div>
<p class="hang">For food that stays our hunger,</p>
<p class="hang">For rest that brings us ease,</p>
<p class="hang">For homes where memories linger,</p>
<p class="hang">We give our thanks for these.</p>
<p class="noindent1">TRADITIONAL ENGLISH BLESSING</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Dance as though no one is watching you,</p>
<p class="hang">Love as though you have never been hurt before,</p>
<p class="hang">Sing as though no one can hear you,</p>
<p class="hang">Live as though heaven is on earth.</p>
<p class="noindent1">ANONYMOUS</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page96"></a><img alt="" src="images/image-96.jpg"/></p>
</div>
<p class="hang">May you be filled with loving kindness.</p>
<p class="hang">May you be well.</p>
<p class="hang">May you be peaceful and at ease.</p>
<p class="hang">May you be happy.</p>
<p class="noindent1">ANCIENT TIBETAN BUDDHIST BLESSING</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page97"></a>Do not seek too much fame,</p>
<p class="hang">But do not seek obscurity.</p>
<p class="hang">Be proud,</p>
<p class="hang">But do not remind the world of your deeds.</p>
<p class="hang">Excel when you must,</p>
<p class="hang">But do not excel the world.</p>
<p class="hang">Many heroes are not yet born,</p>
<p class="hang">Many have already died.</p>
<p class="hang">To be alive to hear this song is a victory.</p>
<p class="noindent1">WEST AFRICAN SONG</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">When you arise in the morning, give thanks for the morning light, for your life and strength.</p>
<p class="hang">Give thanks for your food and the joy of living.</p>
<p class="hang">If you see no reason for giving thanks, the fault<br/>lies in yourself.</p>
<p class="noindent1">TECUMSEH (1768-1813),<br/>CHIEF OF THE SHAWNEE NATION, <i>GIVE THANKS</i></p>
<p class="pagebreak"></p>
<p class="hang"><a id="page98"></a>Lord,</p>
<p class="hang">Bless the food on our table.</p>
<p class="hang">Keep us healthy,</p>
<p class="hang">Strong and able.</p>
<p class="noindent1">MARGARET KENNEDY (1896-1967),<br/>AMERICAN POET AND WRITER</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Lord, I do give Thee thanks,</p>
<p class="hang">For the abundance that is mine.</p>
<p class="hang">Today is here.</p>
<p class="noindent1">ANONYMOUS</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page99"></a>Hark to the chimes,</p>
<p class="hang">Come bow thy head,</p>
<p class="hang">We thank Thee, Lord,</p>
<p class="hang">For this good bread.</p>
<p class="noindent1"><i>CHIMES GRACE</i>, ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Gratitude takes three forms:</p>
<p class="hang">A feeling in the heart, an expression in words, and a giving in return.</p>
<p class="noindent1">ARABIC PROVERB</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">All shall be well,</p>
<p class="hang">And all shall be well,</p>
<p class="hang">And all manner of thing shall be well.</p>
<p class="noindent1">DAME JULIAN OF NORWICH<br/>(CIRCA 1342-1416), ENGLISH MYSTIC</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-100.jpg"/></p>
</div>
<p class="hang"><a id="page101"></a>What is patriotism but a love of the good things we ate in our childhood?</p>
<p class="noindent1">LIN YÜ-T’ANG (1895-1976),<br/>CHINESE PHILOSOPHER AND POET</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page102"></a>Let me smile with the wise and feed with the rich.</p>
<p class="noindent1">DR. SAMUEL JOHNSON (1709-1784),<br/>ENGLISH AUTHOR, LEXICOGRAPHER,<br/>AND CONVERSATIONALIST</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">On such an occasion as this,</p>
<p class="hang">All time and nonsense scorning,</p>
<p class="hang">Nothing shall come amiss,</p>
<p class="hang">And we won’t go home til morning.</p>
<p class="noindent1">JOHN BALDWIN BUCKSTONE (1802-1879),<br/>ENGLISH COMEDIAN AND PLAYWRIGHT</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Lord, for this food make us truly thankful, Amen.</p>
<p class="noindent1">TRADITIONAL BLESSING</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page103"></a>Truly now,</p>
<p class="hang">Double thanks, triple thanks,</p>
<p class="hang">That we’ve been formed,</p>
<p class="hang">We’ve been given our mouths, our faces,</p>
<p class="hang">We speak, we listen, we wonder, we move,</p>
<p class="hang">Our knowledge is good,</p>
<p class="hang">We’ve understood what it is for,</p>
<p class="hang">We hear and we’ve seen</p>
<p class="hang">What is great and small,</p>
<p class="hang">Under the sky and on the earth.</p>
<p class="noindent1">MAYAN BLESSING FROM <i>POPUL VUH</i>, SACRED BOOK OF QUICHE MAYA, GUATEMALA, CIRCA 600 <span class="small">B.C.</span></p>
<div class="image">
<p class="center"><img alt="" src="images/image-103.jpg"/></p>
</div>
<p class="pagebreak"></p>
<p class="hang"><a id="page104"></a>May we walk with grace, and</p>
<p class="hang">May the light of the universe</p>
<p class="hang">Shine upon our path.</p>
<p class="noindent1">ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">O Lord, that lends me life, Lend me a heart replete with thankfulness.</p>
<p class="noindent1">WILLIAM SHAKESPEARE (1564-1616),<br/>ENGLISH WRITER</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="noindent">Thankfulness sets in motion a chain reaction that transforms all around us—including ourselves. For no one ever misunderstands the melody of a grateful heart. Its message is universal; its lyrics transcend all earthly<br/>barriers; its music touches the heavens.</p>
<p class="noindent1">ANONYMOUS</p>
<p class="pagebreak"></p>
<p class="noindent"><a id="page105"></a>It is not the quantity of meat, but the cheerfulness of the guests which makes the feast.</p>
<p class="noindent1">EDWARD HYDE, EARL OF CLARENDON  (1609-1674), <br/>ENGLISH STATESMAN AND HISTORIAN</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="noindent">O Lord God, heavenly Father, bless us and these Thy gifts, which we shall accept from Thy tender goodness. Give us food and drink. Also for our souls unto life eternal, and make us partakers of Thy heavenly table through Jesus Christ.<br/>Amen.</p>
<p class="noindent1">AMISH PRAYER</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page106"></a>Joy and gladness shall be found therein,</p>
<p class="hang">thanksgiving, and the voice of melody.</p>
<p class="noindent1">ISAIAH, 51:3</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">It is a good thing to give thanks unto the Lord,</p>
<p class="hang">And to sing praises unto Thy name, O most High:</p>
<p class="hang">To show forth Thy loving kindness in the morning,</p>
<p class="hang">And Thy faithfulness every night.</p>
<p class="noindent1">PSALM 92:1, 2</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><a id="page107"></a><img alt="" src="images/image-107.jpg"/></p>
</div>
<p class="hang">Thank you very, very much;</p>
<p class="hang">My God, thank you.</p>
<p class="hang">Give me food today,</p>
<p class="hang">Food for my sustenance every day.</p>
<p class="hang">Thank you very, very much.</p>
<p class="noindent1"><i>THANKSGIVING PRAYER</i>,<br/>
  TRADITIONAL SAMBURU BLESSING, KENYA</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page108"></a>Bless this food and us that eats it!</p>
<p class="noindent1">COWBOY GRACE</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">When we count our many blessings;</p>
<p class="hang">It isn’t hard to see,</p>
<p class="hang">That life’s most valued treasures,</p>
<p class="hang">Are the treasures that are free.</p>
<p class="hang">For it isn’t what we own or buy,</p>
<p class="hang">That signifies our wealth.</p>
<p class="hang">It’s the special gifts that have no price:</p>
<p class="hang">Our family, friends, and health.</p>
<p class="noindent1">ANONYMOUS, <i>THE BEST THINGS IN LIFE ARE FREE</i></p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Enter His gates with thanksgiving</p>
<p class="hang">And His courts with praise;</p>
<p class="hang">Give thanks to Him and praise</p>
<p class="hang">His name.</p>
<p class="noindent1">PSALM 100:4</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page109"></a><i>On strawberries:</i></p>
<p class="hang">Doubtless God could have made a better berry, but doubtless God never did.</p>
<p class="noindent1">WILLIAM BUTLER (1535-1618),<br/>ENGLISH WRITER</p>
<div class="image">
<p class="center"><img alt="" src="images/image-109.jpg"/></p>
</div>
<p class="noindent">Nothing is more graceful than when merriment possesses all the people, and banqueters listen in the halls to the singer, sitting in order, and the tables beside them are filled with bread and meat, and the wine pourer brings wine decanted from the bowl and pours it in the cups.</p>
<p class="noindent1">HOMER (CIRCA 700 <span class="small">B.C.</span>), GREEK POET</p>
<p class="pagebreak"></p>
<div class="floatleft">
<p class="hang"><a id="page110"></a><img alt="" src="images/image-110.jpg"/></p>
</div>
<p class="noindent-space1">No ordinary meal—a sacrament awaits us.<br/>On our tables daily spread,<br/>For men are risking lives on sea and land,<br/>That we may dwell in safety and be fed.</p>
<p class="noindent1">SCOTTISH GRACE</p>
<div class="clear"></div>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-111.jpg"/></p>
</div>
<div class="image">
<p class="center"><a id="page112"></a><img alt="" src="images/image-112.jpg"/></p>
</div>
<p class="hang">O precious food! Delight of the mouth!</p>
<p class="hang">O, much better than gold, masterpiece of Apollo!</p>
<p class="hang">O flower of all fruits!</p>
<p class="hang">O ravishing melon!</p>
<p class="noindent1">MARC-ANTOINE GIRARD, SIEUR DE SAINT-AMANT<br/>(1594-1661), FRENCH POET</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">All human history attests,</p>
<p class="hang">That happiness for men—</p>
<p class="hang">The happy sinner!—since Eve ate apples,</p>
<p class="hang">Much depends on dinner.</p>
<p class="noindent1">GEORGE GORDON, LORD BYRON<br/>(1788-1824), ENGLISH POET</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page113"></a>God be my unfolding,</p>
<p class="hang">God be my circle,</p>
<p class="hang">God be in my words,</p>
<p class="hang">God be in my thoughts.</p>
<p class="noindent1">HEBRIDEAN PRAYER</p>
<div class="image">
<p class="center"><img alt="" src="images/image-113.jpg"/></p>
</div>
<p class="hang">At this time, O Lord,</p>
<p class="hang">We are especially thankful for the golden ripe grain,</p>
<p class="hang">And for the hundred kind of red fruits.</p>
<p class="hang">Where do they come from? O Lord, they are Thine.</p>
<p class="noindent1"><i>THANKS AT HARVEST</i>, KOREAN BLESSING</p>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-114.jpg"/></p>
</div>
<p class="noindent"><a id="page115"></a>It is around the table that friends understand best the warmth of being together.</p>
<p class="noindent1">ITALIAN SAYING</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page116"></a>My God, I thank Thee, who hast made</p>
<p class="hang">The Earth so bright,</p>
<p class="hang">So full of splendor and of joy;</p>
<p class="hang">Beauty and light!</p>
<p class="hang">So many glorious things are here,</p>
<p class="hang">Noble and right!</p>
<p class="noindent1">ADELAIDE ANNE PORTER (1825-1864),<br/>AMERICAN WRITER</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Bless all the fruits and vegetables that grace our planet.</p>
<p class="hang">Especially the kumquat, rutabaga, and pomegranate.</p>
<p class="noindent1">ANONYMOUS</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">For these and all His mercies,</p>
<p class="hang">God’s holy name be praised and thanked,</p>
<p class="hang">Through Jesus Christ our Lord. Amen</p>
<p class="noindent1">REV. ALLAN HOUSE O’NEIL, ST. JOHN’S<br/>EPISCOPAL CHURCH, WEST HARTFORD, CT</p>
<p class="pagebreak"></p>
<p class="hang"><a id="page117"></a>We return thanks to our mother, the Earth, which sustains us.</p>
<p class="hang">We return thanks to the rivers and streams, which supply us with water.</p>
<p class="hang">We return thanks to all herbs, which furnish medicines for the cure of our diseases.</p>
<p class="hang">We return thanks to the moon and stars, which have given to us their light when the sun was gone.</p>
<p class="hang">We return thanks to the sun, which has looked upon the Earth with a beneficent eye.</p>
<p class="hang">Lastly, we return thanks to the Great Spirit, in Whom is embodied all goodness, and Who directs all things for the good of Her children.</p>
<p class="noindent1">THANKSGIVING PRAYER, IROQUOIS</p>
<p class="pagebreak"></p>
<p class="noindent"><a id="page118"></a>Salutations! O Merciful God who provides food for the body and soul, you have kindly granted what is spread before us. We thank you. Bless the loving hands that prepared this meal and us who are to enjoy it, please. Homage, homage, homage to thee!</p>
<p class="noindent1">TAMIL PRAYER, MANIKKA VASAHAR<br/>(8TH CENTURY), SOUTHERN INDIA</p>
<div class="image">
<p class="center"><img alt="" src="images/image-118.jpg"/></p>
</div>
<p class="pagebreak"></p>
<div class="image">
<p class="center"><img alt="" src="images/image-119.jpg"/></p>
</div>
<p class="hang"><a id="page120"></a>To the precious Buddha, unsurpassable Teacher,</p>
<p class="hang">To the precious Dharma, unsurpassable Refuge,</p>
<p class="hang">To the precious Sangha, unsurpassable Guide,</p>
<p class="hang">To the three Jewels, the sources of Refuge, I make this Offering.</p>
<p class="noindent1">TIBETAN BUDDHIST PRAYER</p>
<div class="image">
<p class="center"><img alt="" src="images/image-10.jpg"/></p>
</div>
<p class="hang">Blessed be.</p>
<p class="noindent1">ANCIENT CELTIC BLESSING</p>
<div class="image">
<p class="center"><img alt="" src="images/image-120.jpg"/></p>
</div>
<p class="pagebreak"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005chapter1.vue?02ba5a66